import ListItem from '../utils/ListItem';

function SourcesListItem(props) {
  const isWebsite = props.media === 'Website';
  const linkStyle = { display: 'block', width: '100%', textDecoration: 'none' };
  const item = (
    <ListItem
      to="#"
      primary={props.name}
      secondary={props.origin}
      meta={props.media}
    />
  );

  if (isWebsite && props.origin) {
    return (
      <a href={props.origin} target="_blank" rel="noopener noreferrer" style={linkStyle}>
        {item}
      </a>
    );
  }

  return item;
}

export default SourcesListItem;
